import {State} from 'lib/store'
import {TabsState} from 'lib/tabs'
import {createSelector} from 'reselect'

const selectNotificationsFeature = (state: State): TabsState => state.tabs

export const getTab = createSelector(selectNotificationsFeature, tabs => tabs.tab)
